import React from "react";
import {DataTable, Modal, P} from "@tag/tag-components-react-v4";
import {CustomerDTO} from "../../types/CustomerDTO";
import {useMsal, useIsAuthenticated} from "@azure/msal-react";
import AppRolesService from "../../../General/services/AppRolesService";

function EvoDetails(props: { visible: boolean, selectedCustomer: CustomerDTO, handleClose: Function }) {
    const {accounts} = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const isAdmin = AppRolesService.isUserAdmin(accounts, isAuthenticated);

    const columns = React.useMemo(
        () => [
            { accessorKey: 'displayName', header: 'Property'},
            { accessorKey: 'value', header: 'Value'}
        ],
        [],
    );

    const data = [
        {
            key: 'organisationId',
            displayName: 'Organisation ID',
            value: props.selectedCustomer.evoOrganisationId
        },
        {
            key: 'private',
            displayName: 'Private Key',
            value: isAdmin ? props.selectedCustomer.privateKey : "Please check the Evo admin tool"
        },
        {
            key: 'public',
            displayName: 'Public Key',
            value: props.selectedCustomer.publicKey
        }
    ]

    const renderModalContent = () => {
        return (
            <DataTable
                columns={columns}
                data={data}
                noDataElement={<P>Sorry, there is no Evo Data available.</P>}
            />
        )
    }

    let content;
    content =
        <Modal
            visible={props.visible}
            accent='purple'
            heading={`Evo Details`}
            primaryButtonProps={{buttonStyle: {'display': 'none'}}}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
        >
            <div style={{marginTop: '16px'}}>
                {renderModalContent()}
            </div>
        </Modal>

    return (
        <>
            {content}
        </>
    )
}

export default EvoDetails;
